module.exports = __webpack_public_path__ + "static/media/create_collection.7eb27b6c.svg";